import {
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  Input,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ModalComponent } from '../../../components/modal.component';
import { ContentService } from '../../../services/content.service';
import { Vendor } from '../../../interfaces/vendor';

@UntilDestroy()
@Component({
  selector: 'app-vendor-modal',
  templateUrl: './vendor-modal.component.html',
  styleUrls: ['./vendor-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class VendorModalComponent implements OnInit {
  @Input() buttonLabel = '';
  @Input() vendorLabel: string;
  @ViewChild('vendorModal', { static: true }) vendorModal: ModalComponent;
  public vendors: Vendor[];

  constructor(private contentService: ContentService) {}

  ngOnInit() {
    this.vendors = [];
    if (!this.buttonLabel && this.vendorLabel === 'IMS') {
      this.buttonLabel = 'Sold by Anheuser-Busch, Shipping from ';
    }
  }

  getVendorInfo(): void {
    this.contentService
      .get('vendor')
      .pipe(untilDestroyed(this))
      .subscribe((response) => {
        let vendors: Array<Vendor> = JSON.parse(response.data);
        if (this.vendorLabel) {
          vendors =
            vendors.filter((vendor) => vendor.label === this.vendorLabel) || [];
        }
        this.vendors = vendors;
      });
  }

  toggleModal(): void {
    if (this.vendorModal.isVisible()) {
      this.vendorModal.hide();
    } else {
      this.getVendorInfo();
      this.vendorModal.show();
    }
  }

  getEmailLink(email: string): string {
    return `mailto:${email}`;
  }
}
